import React from 'react';
import { Check } from 'lucide-react';

const STEP_LABELS = ['المكان', 'الأبعاد', 'الإضاءة', 'النتائج'];

interface WizardProgressProps {
  currentStep: number;
  totalSteps: number;
}

export default function WizardProgress({ currentStep }: WizardProgressProps) {
  return (
    <div className="mb-10">
      <div className="flex items-center justify-between mb-4">
        {STEP_LABELS.map((label, index) => {
          const stepNum = index + 1;
          const isDone = stepNum < currentStep;
          const isActive = stepNum === currentStep;

          return (
            <React.Fragment key={`step-${stepNum}`}>
              <div className="flex flex-col items-center gap-2">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-300 ${
                    isDone
                      ? 'bg-success text-white'
                      : isActive
                      ? 'bg-primary text-white shadow-primary'
                      : 'bg-muted text-muted-foreground'
                  }`}
                >
                  {isDone ? <Check size={16} /> : stepNum}
                </div>
                <span
                  className={`text-xs font-semibold hidden sm:block ${
                    isActive ? 'text-primary' : isDone ? 'text-success' : 'text-muted-foreground'
                  }`}
                >
                  {label}
                </span>
              </div>
              {index < STEP_LABELS.length - 1 && (
                <div className="flex-1 mx-2 h-0.5 relative">
                  <div className="absolute inset-0 bg-muted rounded-full" />
                  <div
                    className="absolute inset-0 bg-primary rounded-full transition-all duration-500"
                    style={{ width: stepNum < currentStep ? '100%' : '0%' }}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${((currentStep - 1) / 3) * 100}%` }}
        />
      </div>
    </div>
  );
}